<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        v-if="!loadingData"
        align="center"
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />

        <v-img
          src="../../assets/image3.png"
          width="100%"
          max-width="400px"
          class="mx-auto mb-10"
        />
        <p class="text-h5 font-weight-bold">
          {{ $t('confirmMsgTitle') }}
        </p>
        <p
          v-if="code != 'success'"
          class="text-body-1"
        >
          {{ $t('confirmMsgBodyDeleteAccount') }}
        </p>
        <p
          v-else
          class="text-body-1"
        >
          {{ $t('confirmMsgBodyDeleteAccountRegularSpaceMember') }}
        </p>
        <v-form
          ref="form"
          v-model="valid"
          
        >
          <v-row>
            <v-col
              cols="12"
              sm="10"
              md="8"
              offset-sm="1"
              offset-md="2"
            >
              <v-text-field
                v-model="currentPassword"
                data-testid="password-current-input-delete-account"
                solo
                class="rounded-xxl text-body-2"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('deleteAccountPasswordPlaceholder')"
                :rules="passwordRules"
                @click:append="showPassword = !showPassword"
                @keydown.enter.prevent
              />
            </v-col>
          </v-row>
          <v-btn
            ref="cancel"
            data-testid="cancel-button"
            outlined
            elevation="0"
            class="rounded-xxl text-none mr-8 px-4 mt-10"
            @click="$router.go(-1)"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            data-testid="confirm-button"
            :loading="loading"
            color="error"
            class="rounded-xxl text-none px-4 mt-10"
            @click="confirmDeleteAccount()"
          >
            {{ $t('confirmBtn') }}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import { ruleRequired } from '../../rules/formRules.js';
import { logoutAuth} from '../../auth/auth.js'
import { deleteUserAccount,checkUserBeforeDeletion } from '../../api/userApi';
import i18n from '../../plugins/i18n';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data() {
        return{
            valid: true,
            showPassword: false,
            passwordRules: ruleRequired('labelPassword'),
            currentPassword:'',
            userId: window.$cookies.get('id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            loading: false,
            code: '',
            loadingData:false
        }
        
    },
    async created(){
      this.loadingData = true
     await this.checkUserBeforeDeletion()
     this.loadingData = false
    },

    methods:{
        async confirmDeleteAccount(){
            this.$refs.form.validate()
            if(this.valid){
                    this.loading = true
                    try {
                    let data = {
                            data: {
                            type: "users", 
                            id: this.userId,
                            attributes: {
                                confirm_password: this.currentPassword.trim(),
                                deleted_at: this.currentDate(),  
                            }
                        }
                        
                    };
                    const response = await deleteUserAccount(this.userId, data)
                    if(response.status == 200) {
                      
                      window.$cookies.keys().forEach(cookie => window.$cookies.remove(cookie))
                      localStorage.clear();
                      logoutAuth()
                      this.$router.push({name: 'Login', params: {successfullyDeletedAccount: true}})

                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if(e.response.status == 401){
                             this.alertType = 'error'
                             this.alertMsg =  i18n.t('serverError')
                        }else if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The password did not match!'){
                                     this.alertType = 'error'
                                     this.alertMsg = i18n.t('editUserErrorWrongCurrentPassword')
                                }else{
                                 this.alertType = 'error'
                                 this.alertMsg =  i18n.t('serverError')
                                }
                            }
                        }
                        else if (e.response.status == 404 ) {
                             this.alertType = 'error'
                             this.alertMsg =  i18n.t('serverError')
                        }
                        else{
                             this.alertType = 'error'
                             this.alertMsg =  i18n.t('serverError')
                        }
                    }
                }
                this.loading = false
            }
        },
        async checkUserBeforeDeletion(){
            try {
                const response = await checkUserBeforeDeletion() 
                if(response.status == 200) {
                   this.code = response.data.meta.code
                }
            } catch (e) {
              if(e.response){
                        if (e.response.status == 403 ){ 
                          // this.dialogVisibleDeleteAccount =true
                        }
                        else{
                          this.alertValue = true
                          this.alertType = 'error'
                          this.alertMsg =  i18n.t('serverError')
                        }
                        
                }
                
            }
        },
    }
}
</script>
